import { render, staticRenderFns } from "./AppMoneyLight.vue?vue&type=template&id=3215e11e&lang=pug"
import script from "./AppMoneyLight.vue?vue&type=script&lang=js"
export * from "./AppMoneyLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports